import $ from "jquery";

function setupIncrement(parentSelector, parseLocalizedFloat) {
    var buttons = $('[data-increment-action]');

    if (parentSelector) {
        buttons = $(parentSelector).find('[data-increment-action]');
    }

    buttons
        .off('click.increment')
        .on('click.increment', function () {
            var button = $(this);
            var inputGroup = button.closest('.input-group');
            var input = inputGroup.find('input.form-control[data-increment-visible="true"]').first();
            var hidden = inputGroup.find('input[type="hidden"][data-increment-hidden="true"]').first();

            if (!input.length || input.is(':disabled') || input.is('[readonly]')) {
                return;
            }

            var amount = parseFloat(button.attr('data-increment-amount') || '0');
            if (!amount) {
                return;
            }

            var prefix = input.attr('data-increment-currency-prefix') || '';
            var currentValue = parseLocalizedFloat(stripCurrencyPrefix(input.val(), prefix)) || 0;
            var isIncrement = button.attr('data-increment-action') == 'increment';
            var newValue = currentValue + (isIncrement ? amount : -amount);

            syncCurrencyInputs(input, hidden, prefix, newValue);
            input.trigger('change');
            input.trigger('keyup');
            input.valid();
        });

    var visibleInputs = $('[data-increment-visible="true"]');
    if (parentSelector) {
        visibleInputs = $(parentSelector).find('[data-increment-visible="true"]');
    }

    visibleInputs
        .off('focus.increment blur.increment input.increment change.increment')
        .on('focus.increment', function () {
            var input = $(this);
            input.val(stripCurrencyPrefix(input.val(), input.attr('data-increment-currency-prefix') || ''));
        })
        .on('input.increment change.increment', function () {
            var input = $(this);
            var inputGroup = input.closest('.input-group');
            var hidden = inputGroup.find('input[type="hidden"][data-increment-hidden="true"]').first();
            var prefix = input.attr('data-increment-currency-prefix') || '';
            var numericValue = parseLocalizedFloat(stripCurrencyPrefix(input.val(), prefix));

            if (hidden.length) {
                hidden.val(numericValue == null || Number.isNaN(numericValue) ? '' : numericValue.toString());
                hidden.trigger('change');
                hidden.valid();
            }
        })
        .on('blur.increment', function () {
            var input = $(this);
            var inputGroup = input.closest('.input-group');
            var hidden = inputGroup.find('input[type="hidden"][data-increment-hidden="true"]').first();
            var prefix = input.attr('data-increment-currency-prefix') || '';
            var numericValue = parseLocalizedFloat(stripCurrencyPrefix(input.val(), prefix));

            if (numericValue == null || Number.isNaN(numericValue)) {
                input.val(hidden.length ? hidden.val() : '');
                return;
            }

            syncCurrencyInputs(input, hidden, prefix, numericValue);
            input.trigger('change');
            input.valid();
        });
}

function syncCurrencyInputs(input, hidden, prefix, value) {
    input.val(prefix + value.toString());

    if (hidden.length) {
        hidden.val(value.toString());
        hidden.trigger('change');
        hidden.valid();
    }
}

function stripCurrencyPrefix(value, prefix) {
    if (!value) {
        return value;
    }

    if (prefix && value.startsWith(prefix)) {
        return value.substring(prefix.length);
    }

    return value;
}

export default setupIncrement;
